export default "__VITE_ASSET__BTZgqUdE__"